/* eslint-disable @typescript-eslint/naming-convention */

export enum TRANSLATION_STATE {
  IDLE,
  LOADING,
  ERROR,
  DONE
}
